module.exports = __webpack_public_path__ + "static/media/defaultChallengeImage.61b566fc.png";